export const Loader = () => {
  return (
    <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-10 w-10"></div>
  );
};
